module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-table', {
    attrs: {
      "data-api": this.api.coach.member,
      "key-field": "uid",
      "edit-path": "/main/member/edit",
      "params": _vm.params,
      "deletable": false
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "uid",
      "label": "编码",
      "width": "300"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sex",
      "label": "性别"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "label": "手机"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "comment",
      "label": "备注"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2467e708","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/coach/view/member.vue
// module id = 1122
// module chunks = 2